import * as _ from 'lodash'

import { BaseDto } from "./base.dto"
import { FileDto } from "./file.dto"

import { PagingDto } from "./paging.dto"

export class BannerDto extends BaseDto {
  image?: FileDto
  mobileImage?: FileDto
  link?: string
  enabled?: boolean
  mallId?: string
  v2Link?: string

  static create(data: BannerDto) {
    return _.assign(new BannerDto(), data)
  }
}

export class FindBannerDto extends PagingDto {
  type: string
}

export class CreateBannerDto {
  imageId?: string
  link?: string
  mobileImageId?: string
  mallId?: string
  type?: string
  v2Link?: string
}